import React, { useEffect, useRef } from 'react';

export default function CCTVWebRTCViewer({selectedStream}) {
  const videoRef = useRef(null);
  const pcRef = useRef(null); // RTCPeerConnection 추적

  useEffect(() => {
    let pc;

    const startStream = async () => {
      // 이전 연결 종료
      if (pcRef.current) {
        pcRef.current.getSenders().forEach((s) => pcRef.current.removeTrack(s));
        pcRef.current.close();
        pcRef.current = null;
        if (videoRef.current) videoRef.current.srcObject = null;
      }

      pc = new RTCPeerConnection({
        iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
      });

      pc.addTransceiver('video', { direction: 'recvonly' });
      pc.addTransceiver('audio', { direction: 'recvonly' });

      pc.ontrack = (event) => {
        if (videoRef.current) {
          videoRef.current.srcObject = event.streams[0];
        }
      };

      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);

      await new Promise((resolve) => {
        if (pc.iceGatheringState === 'complete') {
          resolve();
        } else {
          const checkState = () => {
            if (pc.iceGatheringState === 'complete') {
              pc.removeEventListener('icegatheringstatechange', checkState);
              resolve();
            }
          };
          pc.addEventListener('icegatheringstatechange', checkState);
        }
      });

      const res = await fetch(`https://cmms.safewalks.kr:8889/${selectedStream}/whep`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/sdp' },
        body: pc.localDescription.sdp,
      });

      const answer = await res.text();
      await pc.setRemoteDescription({ type: 'answer', sdp: answer });

      pcRef.current = pc;
    };

    startStream();

    return () => {
      if (pcRef.current) {
        pcRef.current.close();
        pcRef.current = null;
        if (videoRef.current) videoRef.current.srcObject = null;
      }
    };
  }, [selectedStream]);

  return (
    <div>
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        controls
        style={{ width: '100%', border: '1px solid #ccc' }}
      />
    </div>
  );
}
